<template>
  <div class='leak-committer-table-cell'>
    <span v-if='isEmptyScore' class="material-icons-outlined empty">
      remove
    </span>
    <span v-else class="value" :title='value'>{{value}}</span>
  </div>
</template>

<script>
export default {
  name: 'LeakCommitterTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    value() {
      return this.item[this.column.field];
    },
    isEmptyScore() {
      return this.value === 'N/A';
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';
.leak-committer-table-cell {
  display: flex;
  align-items: center;
  max-width: 100%;
  .value {
    z-index: 3;
    color: var(--text-primary);
    font-family: $font-family-regular;
    font-size: rem(14);
    letter-spacing: 0;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .empty {
    color: var(--text-secondary);
  }
}
</style>
